import { render, staticRenderFns } from "./BeforeAfterList.vue?vue&type=template&id=53ff6313"
import script from "./BeforeAfterList.vue?vue&type=script&lang=ts"
export * from "./BeforeAfterList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports